import { render, staticRenderFns } from "./Seminuevos.vue?vue&type=template&id=857ef26a&scoped=true&"
import script from "./Seminuevos.vue?vue&type=script&lang=js&"
export * from "./Seminuevos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857ef26a",
  null
  
)

export default component.exports